import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.6665 2.33301C4.11422 2.33301 3.6665 2.78072 3.6665 3.33301V7.99967V12.6664C3.6665 13.2187 4.11422 13.6664 4.6665 13.6664H9.33317C10.2172 13.6664 11.0651 13.3152 11.6902 12.6901C12.3153 12.065 12.6665 11.2171 12.6665 10.3331C12.6665 9.44903 12.3153 8.60119 11.6902 7.97607C11.578 7.86387 11.4586 7.76049 11.3332 7.66639C11.7634 7.09278 11.9998 6.39175 11.9998 5.66634C11.9998 4.78229 11.6486 3.93444 11.0235 3.30932C10.3984 2.6842 9.55056 2.33301 8.6665 2.33301H4.6665ZM8.6665 8.99976L5.6665 8.99967V11.6664H9.33317C9.68679 11.6664 10.0259 11.5259 10.276 11.2759C10.526 11.0259 10.6665 10.6867 10.6665 10.3331C10.6665 9.97947 10.526 9.64033 10.276 9.39028C10.0259 9.14023 9.68679 8.99976 9.33317 8.99976H8.6665ZM5.6665 6.99967V4.33301H8.6665C9.02013 4.33301 9.35926 4.47348 9.60931 4.72353C9.85936 4.97358 9.99984 5.31272 9.99984 5.66634C9.99984 6.01996 9.85936 6.3591 9.60931 6.60915C9.35926 6.8592 9.02013 6.99967 8.6665 6.99967H5.6665Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }